var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3660_11584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.780908 15.9999C0.62637 15.9999 0.475295 15.9541 0.346792 15.8682C0.21829 15.7824 0.118132 15.6604 0.0589893 15.5176C-0.00015362 15.3748 -0.0156252 15.2177 0.0145315 15.0662C0.0446883 14.9146 0.119119 14.7754 0.228408 14.6661L14.6659 0.228609C14.8124 0.0820768 15.0112 -0.000244141 15.2184 -0.000244141C15.4256 -0.000244141 15.6244 0.0820768 15.7709 0.228609C15.9174 0.375141 15.9998 0.573881 15.9998 0.781109C15.9998 0.988337 15.9174 1.18708 15.7709 1.33361L1.33341 15.7711C1.26092 15.8437 1.17479 15.9014 1.07998 15.9406C0.985164 15.9799 0.883528 16 0.780908 15.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2189 15.9999C15.1162 16 15.0146 15.9799 14.9198 15.9406C14.825 15.9014 14.7388 15.8437 14.6664 15.7711L0.228853 1.33361C0.0823209 1.18708 0 0.988337 0 0.781109C0 0.573881 0.0823209 0.375141 0.228853 0.228609C0.375385 0.0820768 0.574125 -0.000244141 0.781353 -0.000244141C0.988581 -0.000244141 1.18732 0.0820768 1.33385 0.228609L15.7714 14.6661C15.8806 14.7754 15.9551 14.9146 15.9852 15.0662C16.0154 15.2177 15.9999 15.3748 15.9408 15.5176C15.8816 15.6604 15.7815 15.7824 15.653 15.8682C15.5245 15.9541 15.3734 15.9999 15.2189 15.9999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3660_11584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMessage);
export default __webpack_public_path__ + "static/media/close-message.95e540e8ada05b01c8936c2929879f32.svg";
export { ForwardRef as ReactComponent };